import axios from "axios";

export const API_BASE = process.env.REACT_APP_API_BASE || "/api/proxy";
const TOKEN_KEY = "lq3_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) =>
  t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API_BASE });

// The mobile backend exposes a parallel "/funcionario/*" namespace for the
// administrative-employee profile. Admin-only endpoints reject that profile
// ("Acesso restrito ao gestor"), so we transparently route to the funcionário
// twin when the logged-in user is an administrativo.
let profileKind = null;
export const setProfileKind = (k) => { profileKind = k; };

// Global base filter. Initialized from localStorage so the persisted selection
// is applied from the very first request (effect ordering is child-first).
let baseId = (typeof localStorage !== "undefined" && localStorage.getItem("lq3_base_id")) || "";
export const setBaseId = (id) => { baseId = id || ""; };
export const getBaseId = () => baseId;

// Após qualquer escrita bem-sucedida, o cache de leituras é invalidado (ver index.js).
let onWrite = null;
export const setOnWrite = (fn) => { onWrite = fn; };

const FUNC_TWINS_EXACT = new Set([
  "bases",
  "drivers",
  "deliveries",
  "deliveries/bulk",
  "deliveries/history",
  "pending-summary",
  "pending-funcionarios",
  "faltas",
  "routes",
  "routes/manual",
  "worked-hours/history",
  "benefits",
  "summary",
]);
const FUNC_TWINS_PATTERNS = [
  /^drivers\/[^/]+\/history$/,
  /^routes\/[^/]+\/audit$/,
  /^routes\/[^/]+\/odometers$/,
  /^faltas\/[^/]+\/review$/,
  /^funcionarios\/[^/]+\/(approve|reject)$/,
];

const routeForProfile = (url) => {
  if (profileKind !== "administrativo" || typeof url !== "string") return url;
  const m = url.match(/^\/admin\/(.+)$/);
  if (!m) return url;
  const rest = m[1];
  const restPath = rest.split("?")[0];
  if (FUNC_TWINS_EXACT.has(restPath) || FUNC_TWINS_PATTERNS.some((re) => re.test(restPath))) {
    return `/funcionario/${rest}`;
  }
  return url;
};

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.url = routeForProfile(cfg.url);
  // Inject the globally-selected base_id (skip when "Todas as bases", when explicitly opted out, or when the caller already set one).
  if (baseId && !cfg.skipBaseId && !(cfg.params && "base_id" in cfg.params)) cfg.params = { ...(cfg.params || {}), base_id: baseId };
  return cfg;
});

api.interceptors.response.use(
  (r) => {
    const m = (r.config?.method || "get").toLowerCase();
    if (m !== "get" && onWrite && !String(r.config?.url || "").startsWith("/auth/")) onWrite();
    return r;
  },
  (err) => {
    if (err?.response?.status === 401 && getToken()) {
      setToken(null);
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const apiError = (err) =>
  err?.response?.data?.detail || err?.message || "Erro inesperado";

export default api;
